module.exports = __webpack_public_path__ + "statics/img/2-8.6b69c47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/2-8.png
// module id = ZKaN
// module chunks = 1